import type { LayoutExecuter } from '../types';
import type { GridLayoutConfig } from './types';

export const grid: LayoutExecuter<GridLayoutConfig> = function (container, children, config) {
  // todo
  return [];
};
